import React, { useState, useEffect } from "react";
import { setTitle } from "../helpers/MetaTag";
import Input from "../components/form/Input";
import Button from "../components/form/Button";
import toastr from "toastr";
import { useNavigate } from "react-router";
import Searching from "../components/Searching";
import NoDataFound from "../components/NoDataFound";
import { useDispatch } from "react-redux";
import { authLogin } from "../store/authSlice";

import { postData } from "../services/api";
import { useTranslation } from "react-i18next";
import Image from "../components/elements/Image";
import { MAIN_LOGO } from "../constant/Constant";
import { Link } from "react-router-dom";

const ActivationCode = () => {
  setTitle(
    "Succession Planning Software for your Business with Succession Now | Activation Code"
  );
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const codeNumber = new URLSearchParams(window.location.search).get("code");
  const [loading, setLoading] = useState(true);
  const [dispalayMessage, setDisplayMessage] = useState("");
  const [isCheck, setIsCheck] = useState(1);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isChangePassword, setIsChangePassword] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(0);

  useEffect(() => {
    const verifyFn = async () => {
      setLoading(true);
      try {
        const userData = await postData("check/activation-code", {
          activation_code: codeNumber,
        });
        if (userData.status && userData.status === 200) {
          setPaymentStatus(userData?.data?.payment_status);
          setLoading(false);
          if (userData?.data?.payment_status === 1) {
            setIsCheck(2);
          } else {
            setIsCheck(3);
          }
        } else {
          setLoading(false);
          setDisplayMessage(userData.message);
        }
      } catch (error) {
        setLoading(false);
        setDisplayMessage(error.message);
      }
    };
    verifyFn();
  }, []);

  const onChangePassword = async (e) => {
    e.preventDefault();
    setIsChangePassword(true);
    try {
      const userData = await postData("create-password", {
        activation_code: codeNumber,
        password: password,
        confirm_password: confirmPassword,
      });
      if (userData.status && userData.status === 200) {
        setIsChangePassword(false);
        toastr.success(userData.message);
        setIsCheck(3);
      } else {
        toastr.error(userData.message);
        setIsChangePassword(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setIsChangePassword(false);
    }
  };

  const checkActivation = async (e) => {
    setProcessing(true);
    // if(paymentStatus && paymentStatus === 1){
    //   try {
    //     const userData = await postData("payment-with-auto-login", {
    //       activation_code : codeNumber,
    //     });
    //     if (userData.status && userData.status === 200) {
    //       setProcessing(false);
    //       toastr.success(userData.message);
    //       dispatch(authLogin(userData.data));
    //       localStorage.setItem("accessToken", userData?.accessToken);
    //       localStorage.setItem("role", userData?.data?.code);
    //     } else {
    //       toastr.error(userData.message);
    //       setProcessing(false);
    //     }
    //   } catch (error) {
    //     toastr.error(error.message);
    //     setProcessing(false);
    //   }
    // }else{
    try {
      const userData = await postData("auto-login", {
        activation_code: codeNumber,
      });
      if (userData.status && userData.status === 200) {
        setProcessing(false);
        toastr.success(userData.message);
        dispatch(authLogin(userData.data));
        localStorage.setItem("accessToken", userData?.accessToken);
        localStorage.setItem("role", userData?.data?.code);
      } else {
        toastr.error(userData.message);
        setProcessing(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setProcessing(false);
    }
    //}
  };

  return (
    <div className="w-full min-h-screen flex justify-center items-center bg-slate-100 py-10">
      <div className="w-full max-w-sm">
        <Link to={"/"}>
          <div className="h-14 w-full flex justify-center object-contain mb-5">
            <Image
              src={MAIN_LOGO}
              alt={""}
              width={"100%"}
              height={"100%"}
              classes={"object-contain object-center"}
            />
          </div>
        </Link>
        <div className="w-full bg-white rounded shadow-md py-8 px-6">
          {isCheck && isCheck === 1 ? (
            <div className="divide-y divide-slate-200 space-y-4">
              {loading ? (
                <Searching label={"Loading..."} />
              ) : (
                <NoDataFound label={dispalayMessage} />
              )}
            </div>
          ) : isCheck && isCheck === 2 ? (
            <div className="divide-y divide-slate-200 space-y-4">
              <div className="relative">
                <h1 className="text-xl font-semibold text-center text-slate-700">
                  {t("create_a_password")}
                </h1>
                <div className="text-sm text-slate-400 text-center font-light">
                  {t("welcome_to_succession_now_please_create_your_password")}
                </div>
              </div>
              <div className="pt-4 space-y-4">
                <div className="relative">
                  <Input
                    label={t("password")}
                    labelClasses={"!text-xs"}
                    inputType={"password"}
                    inputPlaceholder={t("your_password")}
                    inputValue={password}
                    setInput={setPassword}
                    //errorType={''}
                  />
                </div>
                <div className="relative">
                  <Input
                    label={t("confirm_password")}
                    labelClasses={"!text-xs"}
                    inputType={"password"}
                    inputPlaceholder={t("your_password")}
                    inputValue={confirmPassword}
                    setInput={setConfirmPassword}
                    //errorType={''}
                  />
                </div>
                <div className="relative flex justify-center">
                  <Button
                    buttonClasses=""
                    buttonLabelClasses=""
                    buttonType={"button"}
                    buttonIcon={
                      isChangePassword
                        ? "fa-light fa-spinner fa-spin"
                        : "fa-light fa-arrow-right-to-arc"
                    }
                    buttonIconPosition={"left"}
                    buttonLabel={t("save_password")}
                    functions={onChangePassword}
                    buttonHasLink={false}
                    buttonDisabled={isChangePassword}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="bg-gray-100 ">
              <div className="bg-white p-6 mx-auto md:mx-auto">
                {paymentStatus && paymentStatus === 1 && (
                  <div className="text-green-600 w-16 h-16 mx-auto my-6 text-6xl flex items-center justify-center">
                    <i className="fa-solid fa-circle-check"></i>
                  </div>
                )}
                {
                  paymentStatus && paymentStatus === 2 && (
                    <div className="text-green-600 w-16 h-16 mx-auto my-6 text-6xl flex items-center justify-center">
                      <i className="fa-solid fa-circle-check"></i>
                    </div>
                  )
                  // <div className="text-rose-600 w-16 h-16 mx-auto my-6 text-6xl flex items-center justify-center">
                  //   <i className="fa-solid fa-circle-xmark"></i>
                  // </div>
                }
                <div className="text-center">
                  <h3 className="md:text-2xl text-base text-gray-900 font-semibold text-center">
                    {t("account_activated")}
                  </h3>
                  <p className="text-gray-600 my-2">
                    {paymentStatus && paymentStatus === 1
                      ? t("click_the_button_below_to_start_planning")
                      : t("click_the_button_below_to_start_planning")}
                  </p>
                  <div className="py-10 text-center">
                    <Button
                      buttonClasses="mx-auto"
                      buttonLabelClasses=""
                      buttonType={"button"}
                      buttonIcon={
                        processing
                          ? "fa-light fa-spinner fa-spin"
                          : "fa-light fa-arrow-right-to-arc"
                      }
                      buttonIconPosition={"left"}
                      buttonLabel={t("get_started")}
                      functions={checkActivation}
                      buttonHasLink={false}
                      buttonDisabled={processing}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default ActivationCode;
